import { clone } from 'ramda';

import { EBuildingClassType } from '@/packages/api-models/common/json_query';

import { resetTerms, setTerms } from './helpers';
import { EBuildingClass, FOfferType, type NonEmptyArray, type TJsonQuery } from './types';
import { getOfferTypeFromJsonQuery } from './utils';

export function setBuildingClass(jsonQuery: TJsonQuery) {
  return (buildingClass: NonEmptyArray<EBuildingClass> | null): TJsonQuery => {
    const offerType = getOfferTypeFromJsonQuery(jsonQuery);
    const withWarehouse = (offerType & FOfferType.Warehouse) !== 0;
    const isOnlyOffice = offerType === FOfferType.Office;
    let nextJsonQuery = clone(jsonQuery);

    nextJsonQuery = resetTerms(['building_class_type', 'building_class_type__warehouse'])(nextJsonQuery);

    if (!buildingClass) {
      return nextJsonQuery;
    }

    const buildingClassTypes: EBuildingClassType[] = [];
    const warehouseBuildingClassTypes: EBuildingClassType[] = [];

    if (buildingClass.includes(EBuildingClass.A)) {
      const values: EBuildingClassType[] = [EBuildingClassType.A, EBuildingClassType.APlus];

      buildingClassTypes.push(...values);
      if (withWarehouse) {
        warehouseBuildingClassTypes.push(...values);
      }
    }

    if (buildingClass.includes(EBuildingClass.B)) {
      const values: EBuildingClassType[] = [EBuildingClassType.B, EBuildingClassType.BPlus, EBuildingClassType.BMinus];

      buildingClassTypes.push(...values);
      if (withWarehouse) {
        warehouseBuildingClassTypes.push(...values);
      }
    }

    if (buildingClass.includes(EBuildingClass.C)) {
      const values: EBuildingClassType[] = [EBuildingClassType.C, EBuildingClassType.CPlus];

      buildingClassTypes.push(...values);
      if (withWarehouse) {
        warehouseBuildingClassTypes.push(...values);
      }
    }

    if (!isOnlyOffice && buildingClass.includes(EBuildingClass.D)) {
      buildingClassTypes.push(EBuildingClassType.D);
      if (withWarehouse) {
        warehouseBuildingClassTypes.push(EBuildingClassType.D);
      }
    }

    if (buildingClass.length > 0) {
      nextJsonQuery = setTerms('building_class_type')(nextJsonQuery)(buildingClassTypes);
    }

    if (warehouseBuildingClassTypes.length > 0) {
      nextJsonQuery = setTerms('building_class_type__warehouse')(nextJsonQuery)(warehouseBuildingClassTypes);
    }

    return nextJsonQuery;
  };
}
